import {Box as MuiBox} from "@mui/material";
import {cn} from "@/src/shared/utils/mergeTwClasses";

export function Grid(props: any) {
    const { className, columns, style, ...rest } = props;
    return (
        <MuiBox
            className={cn(
                "grid grid-cols-3 max-xl:grid-cols-2 max-md:grid-cols-1",
                className,
                {
                    "grid-cols-1": columns === 1,
                    "grid-cols-2": columns === 2,
                    "grid-cols-3": columns === 3,
                    "grid-cols-4": columns === 4,
                    "grid-cols-5": columns === 5,
                    "grid-cols-6": columns === 6,
                    "grid-cols-7": columns === 7,
                    "grid-cols-8": columns === 8,
                    "grid-cols-9": columns === 9,
                    "grid-cols-10": columns === 10,
                    "grid-cols-11": columns === 11,
                    "grid-cols-12": columns === 12,
                },
            )}
            sx={style}
            {...rest}
        />
    );
}